import React from 'react';
import { Upload, Target, Sparkles, FileDown } from 'lucide-react';
import { HOW_STEPS } from '../../lib/marketing';

const ICONS = [Upload, Target, Sparkles, FileDown];

const Visual = ({ i }) => {
  if (i === 0) return (
    <div className="rounded-xl border border-dashed border-accent/40 bg-accent/5 p-4 text-center">
      <Upload className="mx-auto h-5 w-5 text-accent" aria-hidden="true" />
      <p className="mt-2 text-[11px] font-medium text-primary">Drop your resume or LinkedIn PDF</p>
      <p className="text-[10px] text-muted-foreground">PDF up to 5 MB · or paste text</p>
    </div>
  );
  if (i === 1) return (
    <div className="rounded-xl border border-border bg-white p-3">
      <div className="text-[10px] font-medium text-muted-foreground">Job description</div>
      <div className="mt-1 space-y-1 rounded-md border border-border bg-surface p-2">{[92, 80, 64].map((w) => <div key={w} className="h-1.5 rounded bg-border" style={{ width: `${w}%` }} />)}</div>
      <div className="mt-2 inline-flex rounded-md bg-primary px-2 py-1 text-[10px] font-semibold text-white">Analyze match</div>
    </div>
  );
  if (i === 2) return (
    <div className="rounded-xl border border-border bg-white p-3">
      <p className="text-[10px] text-muted-foreground line-through">Responsible for sales reports.</p>
      <p className="mt-1.5 rounded-md bg-emerald-50 px-2 py-1.5 text-[10px] font-medium leading-snug text-emerald-800">Automated weekly sales reporting in Excel, saving the team ~6 hours per week.</p>
    </div>
  );
  return (
    <div className="flex items-center gap-3 rounded-xl border border-border bg-white p-3">
      <div className="flex h-10 w-8 items-center justify-center rounded border border-border bg-surface text-[9px] font-bold text-muted-foreground">PDF</div>
      <div><div className="text-[11px] font-semibold text-primary">resume-product-designer.pdf</div><div className="text-[10px] text-muted-foreground">A4 · 1 page · ready to submit</div></div>
    </div>
  );
};

export const HowItWorks = ({ steps = HOW_STEPS }) => (
  <ol className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-testid="how-it-works">
    {steps.map((s, i) => {
      const Icon = ICONS[i % ICONS.length];
      return (
        <li key={s.n} className="flex flex-col rounded-2xl border border-border bg-white p-6 transition-shadow duration-200 hover:shadow-[0_12px_32px_-16px_rgba(16,24,40,0.25)]">
          <div className="flex items-center justify-between">
            <span className="text-xs font-semibold text-accent">{s.n}</span>
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-white"><Icon className="h-4 w-4" aria-hidden="true" /></span>
          </div>
          <h3 className="mt-4 text-xl font-bold text-primary">{s.title}</h3>
          <p className="mt-2 flex-1 text-[15px] leading-relaxed text-muted-foreground">{s.desc}</p>
          <div className="mt-5"><Visual i={i} /></div>
        </li>
      );
    })}
  </ol>
);
